import { adapter } from '@seek/tealium-adapter';

export interface AnalyticsEvent {
  event: string;
  attributes: Record<string, unknown>;
}

export interface Analytics<
  LinkEvent extends AnalyticsEvent,
  ViewEvent extends AnalyticsEvent,
> {
  trackLink: (event: LinkEvent) => void;
  trackView: (event: ViewEvent) => void;
}

interface CreateTealiumAdapterParams {
  debug?: boolean;
  baseAttributes?: Record<string, unknown>;
}

export const createTealiumAdapter = <
  LinkEvent extends AnalyticsEvent,
  ViewEvent extends AnalyticsEvent,
>({
  debug = false,
  baseAttributes = {},
}: CreateTealiumAdapterParams = {}): Analytics<LinkEvent, ViewEvent> => {
  if (debug) {
    (window as any).ANALYTICS_DEBUG = true;
  }

  const tealiumAdapter = adapter();
  return {
    trackLink: ({ event, attributes }) =>
      tealiumAdapter.link(event, { ...baseAttributes, ...attributes }),
    trackView: ({ event, attributes }) =>
      tealiumAdapter.view(event, { ...baseAttributes, ...attributes }),
  };
};
